import { useQuery } from "react-query";

import axios from "../../../../utils/authAxios";

const apiBaseUrl =
    process.env.REACT_APP_API_BASEURL +
    "/BusinessLicensePermits";

export type BLPSortDirection = "asc"
    | "desc";

export type BLPSortField =
  | "recordId"
  | "busLicensePermitTypeName"
  | "issuerName"
  | "licenseOrPermitNumber"
  | "issuedDate"
  | "renewedDate"
  | "expiration_Date"
  | "licenseStatus"
  | "isOldLicense"
  | "storeNumber";

export interface BLPTableRowDto {
  recordId: number;
  storeNumber?: string | null;
  busLicensePermitTypeName?: string | null;
  issuerName?: string | null;
  licenseOrPermitNumber?: string | null;
  issuedDate?: string | null;
  renewedDate?: string | null;
  expiration_Date?: string | null;
  licenseStatus?: string | null;
  isOldLicense?: boolean | null;
  isActive?: boolean;
}

export interface BLPTableRequest {
  dashboardFilter?: string | null;
  officeId?: number | null;
  pageNumber: number;
  pageSize: number;
  search?: string | null;
  sortField?: BLPSortField;
  sortDirection?: BLPSortDirection;
}

export interface BLPTableResponse {
  items: BLPTableRowDto[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
}

interface BLPTableApiResponse {
  items?: BLPTableRowDto[];
  Items?: BLPTableRowDto[];

  totalCount?: number;
  TotalCount?: number;

  pageNumber?: number;
  PageNumber?: number;

  pageSize?: number;
  PageSize?: number;
}

export const getBLPTable = async (
  request: BLPTableRequest
): Promise<BLPTableResponse> => {
  const response =
  await axios.get<BLPTableApiResponse>(apiBaseUrl, {
    params: {
      dashboardFilter: request.dashboardFilter?.trim() || undefined,

      officeId: request.officeId ?? undefined,

      pageNumber: request.pageNumber > 0 ? request.pageNumber : 1,

      pageSize: request.pageSize > 0 ? request.pageSize : 10,

      search: request.search?.trim() || undefined,

      sortField: request.sortField ?? "recordId",

      sortDirection: request.sortDirection ?? "desc",
    },
  });

  const result = response.data;

  return {
    items: result.items ?? result.Items ?? [],

    totalCount: result.totalCount ?? result.TotalCount ?? 0,

    pageNumber: result.pageNumber ?? result.PageNumber ?? request.pageNumber,

    pageSize: result.pageSize ?? result.PageSize ?? request.pageSize,
  };
};

export const useBLPTable = (
  request: BLPTableRequest,
  enabled: boolean = true
) => {
  return useQuery(
    [
      "GetBLPTable",

      request.dashboardFilter ?? "TOTAL",

      request.officeId ?? "AllOffices",

      request.pageNumber,

      request.pageSize,

      request.search ?? "",

      request.sortField ?? "recordId",

      request.sortDirection ?? "desc",
    ],
    () => getBLPTable(request),
    {
      enabled,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );
};
